import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';
import { faqItems } from '@/mocks/faq';

const featuredArticles = articles.slice(0, 6);

export default function Home() {
  const [faqOpen, setFaqOpen] = useState<number | null>(null);

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20confident%20woman%20in%20flowing%20dress%20standing%20in%20minimalist%20luxurious%20interior%20with%20warm%20golden%20sunlight%20streaming%20through%20large%20windows%2C%20soft%20cream%20and%20beige%20tones%2C%20editorial%20fashion%20photography%2C%20dreamy%20atmospheric%20lighting&width=1600&height=900&seq=hero-beauty-01&orientation=landscape"
            alt="美女性感魅力养成指南"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30" />
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight text-balance">
              美女性感魅力养成指南
            </h1>
            <p className="text-base md:text-lg text-white/90 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
              探索美女性感的真正内涵，从穿搭、妆容到气质培养，全方位解析如何展现女性独特魅力。让自信从内而外散发，成为更好的自己。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/xinggan-chuanda"
                className="px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                探索穿搭技巧
              </Link>
              <Link
                to="/about"
                className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md font-medium text-sm hover:bg-white/25 transition-colors whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                探索你的魅力之旅
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                五大核心领域，全方位打造属于你的独特魅力
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300"
                >
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors mb-3">
                    <i className={`${cat.icon} text-xl md:text-2xl`} />
                  </div>
                  <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-700 transition-colors text-center whitespace-nowrap">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500 mt-1 text-center hidden sm:block">
                    {cat.description.slice(0, 20)}...
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-10 gap-3">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
                  精选文章
                </h2>
                <p className="text-sm text-foreground-600">
                  最受欢迎的魅力养成指南，帮你一步步成为更好的自己
                </p>
              </div>
              <Link
                to="/category/xinggan-chuanda"
                className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
              >
                查看全部 <i className="ri-arrow-right-line" />
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">
                关于女性魅力养成，你最关心的问题都在这里
              </p>
            </div>
            <div className="space-y-3">
              {faqItems.map((faq, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                    onClick={() => setFaqOpen(faqOpen === index ? null : index)}
                  >
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                      {faq.question}
                    </h3>
                    <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${faqOpen === index ? 'rotate-45' : ''}`}>
                      <i className="ri-add-line text-foreground-500" />
                    </div>
                  </button>
                  <div
                    className={`transition-all duration-300 overflow-hidden ${
                      faqOpen === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter Section */}
        <section className="py-12 md:py-16 bg-accent-100/50">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6 text-center">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-200 text-accent-600 mx-auto mb-4">
              <i className="ri-mail-send-line text-2xl" />
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              订阅魅力周报
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-lg mx-auto">
              每周获取最新的穿搭灵感、妆容教程和气质提升干货，让你的魅力持续升级
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9s96esnlsngrm4lmigg"
              method="POST"
              className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
            >
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱地址"
                className="flex-1 w-full px-4 py-3 text-sm bg-background-50 border border-background-300 rounded-md focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button
                type="submit"
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                免费订阅
              </button>
            </form>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org WebPage */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "美女性感魅力养成指南 - 首页",
          "description": "探索美女性感的真正内涵，从穿搭、妆容到气质培养，全方位解析如何展现女性独特魅力。",
          "url": "https://yourdomain.com/",
          "inLanguage": "zh-CN",
          "isPartOf": {
            "@type": "WebSite",
            "name": "美女性感魅力养成指南",
            "url": "https://yourdomain.com/"
          }
        })
      }} />

      {/* Schema.org FAQPage */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqItems.map((faq) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })
      }} />
    </>
  );
}